import React from 'react'
import { useRouter } from 'next/router'

import { BookEnum } from '@interfaces/BookEnum'
import { useAuthentication } from '@hooks/useAuthentication'
import { useGetRecommendationBooks } from '@hooks/category/useGetRecommendationBooks'
import { RecommendPageProps } from './interface'

export function withRecommendPage(Component: React.FC<RecommendPageProps>) {
  function WithRecommendPage() {
    const { query } = useRouter()

    const { isUserLoading } = useAuthentication()
    const {
      data: recommendsData,
      isLoading,
      isLoadingToggleBookLike,
      handleLikeBook,
    } = useGetRecommendationBooks({
      categoryId: Number(query?.categoryId),
      bookType: query?.bookType as BookEnum,
      isEbook: !!query?.isEbook,
      limitPerPage: 50,
    })

    const newProps = {
      data: recommendsData,
      total: recommendsData?.length || 0,
      isLoading: isLoading || isUserLoading,
      isLoadingToggleBookLike,
      handleLikeBook,
    }
    return <Component {...newProps} />
  }
  return WithRecommendPage
}
